var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { Stack, TextField } from '@mui/material';
import classNames from 'classnames';
import { createReactTooltip } from '../../common/tooltip';
import { getVersionBrowserColoringClass } from '../../versionBrowser/utils';
import AccurityIcon from '../../icon/components/AccurityIcon';
var MAX_ROWS_FOCUSED = 50;
var MAX_ROWS_UNFOCUSED = 5;
var MultiLineField = function (_a) {
    var name = _a.name, label = _a.label, value = _a.value, onChange = _a.onChange, disabled = _a.disabled, errorMessage = _a.errorMessage, className = _a.className, tooltip = _a.tooltip, coloring = _a.coloring, inherited = _a.inherited;
    var _b = useState(false), focused = _b[0], setFocused = _b[1];
    var _c = createReactTooltip(tooltip, 'multiLineField-' + name), tooltipElement = _c.tooltipElement, tooltipAnchorParams = _c.tooltipAnchorParams;
    return (React.createElement("div", { className: classNames('multiLineField', className, getVersionBrowserColoringClass(coloring)) },
        React.createElement(Stack, { position: "absolute", right: "0", direction: "row", sx: { zIndex: 3 } }, inherited && React.createElement(AccurityIcon, { iconName: "mui:LayersOutlined", fontSize: "small", color: "secondary700" })),
        React.createElement(TextField, __assign({ value: value, onChange: function (e) { return onChange(e.currentTarget.value); }, label: label, error: !!errorMessage, helperText: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.trim(), disabled: disabled, onFocus: function () { setFocused(true); }, onBlur: function () { setFocused(false); }, multiline: true, fullWidth: true, maxRows: focused ? MAX_ROWS_FOCUSED : MAX_ROWS_UNFOCUSED }, tooltipAnchorParams)),
        tooltipElement));
};
export default MultiLineField;
//# sourceMappingURL=MultiLineField.js.map